import { Link, useNavigate } from "react-router-dom";
import "./SignUp.css";
import SimpleReactValidator from "simple-react-validator";
import { useEffect, useRef, useState } from "react";
import Loader from "components/elements/Loader/Loader";
import { setOnboarding, postFormData, getRestData, setUser } from "utils/service";
import { toast } from "react-toastify";
import {
  browserName,
  browserVersion,
  osName,
  osVersion,
} from "react-device-detect";
import FingerprintJS from '@fingerprintjs/fingerprintjs';

const SignUp = () => {
  const navigate = useNavigate();
  const [, forceUpdate] = useState("");
  const [loading, setLoading] = useState(false);
  const [fingerprint, setFingerprint] = useState('');
  const [deviceData, setDeviceData] = useState({
    IPv4: "",
    device_name: "",
    modal_no: "",
    browser_info: "",
    os_version: "",
  });
  const [formData, SetFormData] = useState({
    first_name: "",
    last_name: "",
    cell: "",
    email: "",
    pwd: "",
    confirm_pwd: "",
  });

  useEffect(() => {
    FingerprintJS.load().then(fp => {
      fp.get().then(result => {
        setFingerprint(result.visitorId);
      });
    });
  }, []);

  const handleChange = (e: any) => {
    SetFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
    })
  );

  const getData = async () => {
    let res: any = await getRestData("https://api.ipify.org?format=json");
    setDeviceData({
      IPv4: res.ip,
      device_name: osName,
      modal_no: osVersion,
      browser_info: browserName + " " + browserVersion,
      os_version: osVersion,
    });
    // setIP(res.data.IPv4)
  };

  useEffect(() => {
    getData();
  }, []);

  const handleFormSubmit = async (e: any) => {
    e.preventDefault();
    const formValid = validator.current.allValid();
    if (formValid) {
      // setLoading(true);
      let params: any = {
        cell: formData.cell,
        email: formData.email,
        first_name: formData.first_name,
        last_name: formData.last_name,
        pwd: formData.pwd,
        confirm_pwd: formData.confirm_pwd,
        ip: deviceData.IPv4,
        device_name: deviceData.device_name,
        modal_no: deviceData.modal_no,
        os_version: deviceData.os_version,
        browser_info: deviceData.browser_info,
        device_type: "web",
        imei: fingerprint
      };
      // console.log(JSON.stringify(params, null, 4));
      let response: any = await postFormData("register", params);
      // console.log(JSON.stringify(response, null, 4));
      if (response.success === "true") {
        const onboardingData = {
          ...response,
          path: "exam-type",
          // path: "verify-otp",
          mobile: formData.cell,
        };
        setOnboarding(onboardingData);
        let data = {
          device_id: response.device_id,
          exam_type_id: response.exam_type_id,
          flag: response.flag,
          is_mobile_verify: response.is_mobile_verify,
          token: response.token,
          first_name: response.first_name,
          last_name: response.last_name,
          mobile: response.mobile,
          email: response.email,
          group_id: response.group_id,
          subject_id: response.subject_id,
          is_verified: response.is_verified
        }
        setUser(data);
        toast.success(response.message);
        setLoading(false);
        window.location.href = onboardingData.path;
      } else {
        setLoading(false);
        toast.error(response.message);
      }
    } else {
      validator.current.showMessages();
    }
  };
  return (
    <div className="login-container">
      {loading && <Loader />}
      <div className="d-flex justify-content-center">
        <div className="card">
          <div className="card-header">
            <h3>Create Account</h3>
          </div>
          <div className="card-body">
            <form onSubmit={(e) => handleFormSubmit(e)}>
              <div className="row">
                <div className="col-8 offset-2">
                  <div className="input-group form-group mb-3 d-flex">
                    <div className="d-flex w-100">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="fas fa-user"></i>
                        </span>
                      </div>
                      <input
                        type="text"
                        name="first_name"
                        value={formData.first_name}
                        onChange={handleChange}
                        className="form-control"
                        placeholder="First Name"
                      />
                    </div>

                    {validator.current.message(
                      "first_name",
                      formData.first_name,
                      "required|min:2|max:50",
                      { className: "text-danger" }
                    )}
                  </div>
                  <div className="input-group form-group mb-3 d-flex ">
                    <div className="d-flex w-100">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="fas fa-user"></i>
                        </span>
                      </div>
                      <input
                        type="text"
                        name="last_name"
                        value={formData.last_name}
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Last Name"
                      />
                    </div>

                    {validator.current.message(
                      "last_name",
                      formData.last_name,
                      "required|min:2|max:50",
                      { className: "text-danger" }
                    )}
                  </div>
                  <div className="input-group form-group mb-3 d-flex ">
                    <div className="d-flex w-100">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="fas fa-mobile"></i>+91
                        </span>
                      </div>
                      <input
                        type="text"
                        name="cell"
                        value={formData.cell}
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Mobile Number 10 Digit"
                      />
                    </div>

                    {validator.current.message(
                      "cell",
                      formData.cell,
                      "required|phone:10",
                      { className: "text-danger" }
                    )}
                  </div>
                  <div className="input-group form-group mb-3 d-flex ">
                    <div className="d-flex w-100">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="fas fa-envelope"></i>
                        </span>
                      </div>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Email Address"
                      />
                    </div>

                    {validator.current.message(
                      "email",
                      formData.email,
                      "required|email",
                      { className: "text-danger" }
                    )}
                  </div>
                  <div className="input-group form-group mb-3 d-flex ">
                    <div className="d-flex w-100">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="fas fa-key"></i>
                        </span>
                      </div>
                      <input
                        type="password"
                        name="pwd"
                        value={formData.pwd}
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Password"
                      />
                    </div>

                    {validator.current.message(
                      "pwd",
                      formData.pwd,
                      "required|min:6|max:20",
                      { className: "text-danger" }
                    )}
                  </div>
                  <div className="input-group form-group mb-3 d-flex ">
                    <div className="d-flex w-100">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="fas fa-key"></i>
                        </span>
                      </div>
                      <input
                        type="password"
                        name="confirm_pwd"
                        value={formData.confirm_pwd}
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Re-Enter Password"
                      />
                    </div>

                    {validator.current.message(
                      "confirm_pwd",
                      formData.confirm_pwd,
                      "required|in:" + formData.pwd,
                      {
                        className: "text-danger",
                        messages: { in: "Passwords need to match!" },
                      }
                    )}
                  </div>
                  <div className="form-group">
                    <input
                      type="submit"
                      value="Register"
                      className="btn float-right login_btn"
                    />
                  </div>
                </div>

              </div>

            </form>
          </div>
          <div className="card-footer">
            <div className="d-flex justify-content-center links">
              Already have an account?<Link to="/signin">Sign In</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
